import actionTypePrefixes from "../actions/actionTypePrefixes"

const initialState = {
  reportTypeId: -1,
  reviewId: -1,
  appraisalLevelId: -1,
  includeLeavers: false,
  exportDetails: [],
  selectedEmployees: [],
  selectedLocations: [],
  numberOfSelectedQuestions: 0,
  employeeDetailOptions: [],
  readyToSubmit: false,
}

export default function reportSelectionReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.ReportSelection) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.ReportSelection, "")

  const validateForm = (
    employees,
    locations,
    reportType,
    numberOfQuestions,
    employeeDetailOptions
  ) => {
    return (
      employeeDetailOptions.length > 0 &&
      (employees.length > 0 || locations.length > 0) &&
      (reportType === 1 ||
        reportType === 4 ||
        reportType === 5 ||
        (reportType === 0 && numberOfQuestions > 0))
    ) // Goal or L&D export, or a review export that has had questions selected already
  }

  switch (actionType) {
    case "SET_REPORT_TYPE":
      return {
        ...state,
        reportTypeId: action.reportType,
        readyToSubmit: validateForm(
          state.selectedEmployees,
          state.selectedLocations,
          action.reportType,
          state.numberOfSelectedQuestions,
          state.employeeDetailOptions
        ),
      }
    case "SET_REVIEW_ID":
      return {
        ...state,
        reviewId: action.reviewId,
        exportDetails: [
          {
            id: 1,
            name: "CustomReport.Common.DefaultInitialSheetName",
            selectedQuestions: [],
          },
        ],
      }
    case "SET_APPRAISAL_LEVEL_ID":
      return {
        ...state,
        appraisalLevelId: action.appraisalLevelId,
      }
    case "SET_INCLUDE_LEAVERS":
      return {
        ...state,
        includeLeavers: action.includeLeavers,
      }
    case "SET_INCLUDE_PERFORMANCE":
      return {
        ...state,
        includePerformance: action.includePerformance,
      }
    case "SET_LOCATIONS_AND_EMPLOYEES":
      return {
        ...state,
        selectedEmployees: action.employees || [],
        selectedLocations: action.locations || [],
        readyToSubmit: validateForm(
          action.employees,
          action.locations,
          state.reportTypeId,
          state.numberOfSelectedQuestions,
          state.employeeDetailOptions
        ),
      }

    case "SET_EMPLOYEE_DETAIL_OPTIONS":
      return {
        ...state,
        employeeDetailOptions: action.employeeDetailOptions,
        readyToSubmit: validateForm(
          state.selectedEmployees,
          state.selectedLocations,
          state.reportTypeId,
          state.numberOfSelectedQuestions,
          action.employeeDetailOptions
        ),
      }
    case "SET_SELECTED_QUESTIONS":
      return {
        ...state,
        exportDetails: action.exportDetails,
        numberOfSelectedQuestions: action.numberOfSelectedQuestions,
        readyToSubmit: validateForm(
          state.selectedEmployees,
          state.selectedLocations,
          state.reportTypeId,
          action.numberOfSelectedQuestions,
          state.employeeDetailOptions
        ),
      }
    case "RESET_REPORT_SELECTION":
      return {
        ...state,
        reportTypeId: -1,
        reviewId: -1,
        appraisalLevelId: -1,
        includeLeavers: false,
        exportDetails: [],
        selectedEmployees: [],
        selectedLocations: [],
        employeeDetailOptions: [],
        numberOfSelectedQuestions: 0,
        readyToSubmit: false,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/reportSelectionReducer.js